import { get, post } from "../GenericServices";

const TsReport = {
  getEmployee: () => {
    return get(`timesheet-report/employee`);
  },
  getProjectTasks: (queryString) => {
    return get(`timesheet-report/project-task?${queryString}`);
  },
  getProject: () => {
    return get(`timesheet-report/project`);
  },
  getServices: () => {
    return get(`timesheet-report/service`);
  },
  getTimesheetList: (queryString) => {
    return get(`timesheet-report?${queryString}`);
  },
  exportReport: (queryString) => {
    return post(`timesheet/report/export?${queryString}`);
  },
};

export default TsReport;
